<template>
  <b-modal body-class="m-2" size="lg" id="comms-send-modal" :title="title" ref="sendModal"
     @ok="submit" :ok-disabled="okDisabled" ok-title="Send">
    <form action="/communications/private" method="post" ref="form">
        <mainstage-text
          class="col"
          prefix="communication"
          label="Subject"
          field="subject"
          v-model="editSubject"
        />
       <div class="form-group col">
          <label for="communication[body]" class="mainstage-form-label">Body</label>
            <markdown-editor
              id="communication[body]" name="communication[body]" 
              disable-underline="true"
              v-model="editBody" placeholder="your message goes here..."
              :focus="isReply"
            />
       </div>
      
       <csrf-token/>
       <input v-if="toUserId" type="hidden" name="communication[to_user_id]" :value="toUserId">
       </div>
    </form>
  </b-modal>
</template>

<script>
export default {
  props: ["subject", "body", "name", "to-user-id", "is-reply", "company-name"],
  data() {
   return { 
      editSubject: "",
      editBody: ""
   }
  }, 
  methods: {
    submit() {
      this.$refs.form.submit()
    },
    show() {
      this.editSubject = this.subject
      this.editBody = this.body
      this.$refs.sendModal.show()
    }
  },
  computed: {
    okDisabled() {
      return !this.editSubject || !this.editBody
    },
    title() {
      let name

      if ( this.toUserId && this.name ) { 
         name = this.name
      } else if ( this.companyName ) {
         name = this.companyName 
      } else { 
         return ""
      }


     if ( this.isReply ) { 
        return `Replying to ${name}`
     } else {
        return `Send a message to ${name}`
     }
    }
  }
}
</script>
